
export default {
  "solar-map-api": {
    url: "https://solar-man.steel-hub.app"
  }
}

